import { motion } from 'framer-motion';

interface TodayButtonProps {
  onClick: () => void;
}

export const TodayButton = ({ onClick }: TodayButtonProps) => {
  return (
    <motion.button
      className="relative group w-full sm:w-auto"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      aria-label="आज का दिशा-शूल देखें"
    >
      <div className="relative px-8 py-4 bg-gradient-to-r from-purple-600 to-purple-800 rounded-lg overflow-hidden w-full">
        <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
        <div className="absolute inset-0 border-2 border-white rounded-lg"></div>
        <span className="relative text-2xl font-bold text-white whitespace-nowrap">
          आज का दिशा-शूल
        </span>
      </div>
      
      <div className="absolute inset-0 bg-purple-400 opacity-0 group-hover:opacity-20 rounded-lg filter blur-xl transition-opacity duration-300"></div>
    </motion.button>
  );
};